import { useState, useEffect } from 'react';

const cache = { index: null, meta: null };

export default function useBlogPosts() {
  const [posts, setPosts] = useState(cache.index || []);
  const [meta, setMeta] = useState(cache.meta || { categories: [], tags: [] });
  const [loading, setLoading] = useState(!cache.index);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (cache.index && cache.meta) return;

    let cancelled = false;

    async function fetchData() {
      try {
        const [indexRes, metaRes] = await Promise.all([
          fetch('/content/blog/index.json'),
          fetch('/content/blog/meta.json'),
        ]);

        if (!indexRes.ok || !metaRes.ok) {
          throw new Error('Failed to load blog data');
        }

        const indexData = await indexRes.json();
        const metaData = await metaRes.json();

        if (!cancelled) {
          cache.index = indexData;
          cache.meta = metaData;
          setPosts(indexData);
          setMeta(metaData);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message);
          setLoading(false);
        }
      }
    }

    fetchData();
    return () => { cancelled = true; };
  }, []);

  return { posts, meta, loading, error };
}
